import {
  // Документи
  FileTextOutlined, FilePdfOutlined, FileExcelOutlined, FileWordOutlined,
  ContainerOutlined, ProfileOutlined, SnippetsOutlined, FormOutlined,
  // Довідники / дані
  DatabaseOutlined, BookOutlined, TagsOutlined, AppstoreOutlined,
  TableOutlined, UnorderedListOutlined, FolderOpenOutlined, FolderOutlined,
  // Звіти / аналітика
  BarChartOutlined, PieChartOutlined, LineChartOutlined,
  FundOutlined, DotChartOutlined, AreaChartOutlined,
  // Бухгалтерія / фінанси
  BankOutlined, DollarOutlined, CalculatorOutlined, AccountBookOutlined,
  CreditCardOutlined, EuroOutlined, MoneyCollectOutlined, WalletOutlined,
  PercentageOutlined,
  // Торгівля / склад
  ShoppingCartOutlined, ShoppingOutlined, ShopOutlined,
  GiftOutlined, InboxOutlined, DropboxOutlined,
  // Транспорт
  CarOutlined, RocketOutlined, CloudUploadOutlined, CloudDownloadOutlined,
  // Люди / HR
  UserOutlined, TeamOutlined, IdcardOutlined, ContactsOutlined, SolutionOutlined,
  UsergroupAddOutlined,
  // Налаштування / інструменти
  ToolOutlined, SettingOutlined, ApiOutlined, ControlOutlined, ExperimentOutlined,
  // Організація / структура
  HomeOutlined, ApartmentOutlined, ClusterOutlined, GlobalOutlined, BuildOutlined,
  // Безпека / нотифікації
  SafetyOutlined, AuditOutlined, FlagOutlined, StarOutlined,
  BellOutlined, MailOutlined, CloudOutlined, LockOutlined,
} from '@ant-design/icons';
import type React from 'react';

/**
 * Курований реєстр AntD-іконок для IconPicker (Sprint 19+).
 * Ключі (рядки) — те, що зберігається у `iconKey` поле БД для:
 *  • SubsystemItem (елементи меню підсистем)
 *  • MetaDocumentType (іконка типу документа у меню)
 *  • Subsystem (іконка самої підсистеми у бічному меню)
 *
 * Якщо потрібна нова іконка — додати рядок сюди + import. Усі AntD-іконки
 * доступні через єдину rendering-функцію `acqRenderIcon(key)`.
 */
export interface IconCategory {
  label: string;
  icons: { key: string; label: string }[];
}

export const ICON_CATEGORIES: IconCategory[] = [
  {
    label: 'Документи',
    icons: [
      { key: 'FileTextOutlined', label: 'Документ' },
      { key: 'FilePdfOutlined', label: 'PDF' },
      { key: 'FileExcelOutlined', label: 'Excel' },
      { key: 'FileWordOutlined', label: 'Word' },
      { key: 'ContainerOutlined', label: 'Контейнер' },
      { key: 'ProfileOutlined', label: 'Профіль/анкета' },
      { key: 'SnippetsOutlined', label: 'Виписка' },
      { key: 'FormOutlined', label: 'Форма' },
    ],
  },
  {
    label: 'Довідники',
    icons: [
      { key: 'DatabaseOutlined', label: 'База даних' },
      { key: 'BookOutlined', label: 'Книга' },
      { key: 'TagsOutlined', label: 'Теги' },
      { key: 'AppstoreOutlined', label: 'Каталог' },
      { key: 'TableOutlined', label: 'Таблиця' },
      { key: 'UnorderedListOutlined', label: 'Список' },
      { key: 'FolderOpenOutlined', label: 'Папка (відкрита)' },
      { key: 'FolderOutlined', label: 'Папка' },
    ],
  },
  {
    label: 'Звіти',
    icons: [
      { key: 'BarChartOutlined', label: 'Стовпчики' },
      { key: 'PieChartOutlined', label: 'Кругова' },
      { key: 'LineChartOutlined', label: 'Лінійна' },
      { key: 'FundOutlined', label: 'Тренд' },
      { key: 'DotChartOutlined', label: 'Точкова' },
      { key: 'AreaChartOutlined', label: 'Область' },
    ],
  },
  {
    label: 'Фінанси',
    icons: [
      { key: 'BankOutlined', label: 'Банк' },
      { key: 'DollarOutlined', label: 'Долар' },
      { key: 'EuroOutlined', label: 'Євро' },
      { key: 'CalculatorOutlined', label: 'Калькулятор' },
      { key: 'AccountBookOutlined', label: 'Книга обліку' },
      { key: 'CreditCardOutlined', label: 'Картка' },
      { key: 'MoneyCollectOutlined', label: 'Гроші' },
      { key: 'WalletOutlined', label: 'Гаманець' },
      { key: 'PercentageOutlined', label: 'Відсоток' },
    ],
  },
  {
    label: 'Торгівля / Склад',
    icons: [
      { key: 'ShoppingCartOutlined', label: 'Кошик' },
      { key: 'ShoppingOutlined', label: 'Покупка' },
      { key: 'ShopOutlined', label: 'Магазин' },
      { key: 'GiftOutlined', label: 'Подарунок' },
      { key: 'InboxOutlined', label: 'Inbox' },
      { key: 'DropboxOutlined', label: 'Коробка' },
    ],
  },
  {
    label: 'Транспорт',
    icons: [
      { key: 'CarOutlined', label: 'Авто' },
      { key: 'RocketOutlined', label: 'Ракета' },
      { key: 'CloudUploadOutlined', label: 'Upload' },
      { key: 'CloudDownloadOutlined', label: 'Download' },
    ],
  },
  {
    label: 'Люди / HR',
    icons: [
      { key: 'UserOutlined', label: 'Користувач' },
      { key: 'TeamOutlined', label: 'Команда' },
      { key: 'IdcardOutlined', label: 'ID-картка' },
      { key: 'ContactsOutlined', label: 'Контакти' },
      { key: 'SolutionOutlined', label: 'Резюме' },
      { key: 'UsergroupAddOutlined', label: 'Додати група' },
    ],
  },
  {
    label: 'Інструменти',
    icons: [
      { key: 'ToolOutlined', label: 'Інструмент' },
      { key: 'SettingOutlined', label: 'Налаштування' },
      { key: 'ApiOutlined', label: 'API' },
      { key: 'ControlOutlined', label: 'Контроль' },
      { key: 'ExperimentOutlined', label: 'Експеримент' },
    ],
  },
  {
    label: 'Структура',
    icons: [
      { key: 'HomeOutlined', label: 'Головна' },
      { key: 'ApartmentOutlined', label: 'Підрозділ' },
      { key: 'ClusterOutlined', label: 'Кластер' },
      { key: 'GlobalOutlined', label: 'Глобально' },
      { key: 'BuildOutlined', label: 'Будівля' },
    ],
  },
  {
    label: 'Інше',
    icons: [
      { key: 'SafetyOutlined', label: 'Безпека' },
      { key: 'AuditOutlined', label: 'Аудит' },
      { key: 'FlagOutlined', label: 'Прапор' },
      { key: 'StarOutlined', label: 'Зірка' },
      { key: 'BellOutlined', label: 'Сповіщення' },
      { key: 'MailOutlined', label: 'Пошта' },
      { key: 'CloudOutlined', label: 'Хмара' },
      { key: 'LockOutlined', label: 'Замок' },
    ],
  },
];

const ICON_COMPONENTS: Record<string, React.ComponentType<{ style?: React.CSSProperties }>> = {
  FileTextOutlined, FilePdfOutlined, FileExcelOutlined, FileWordOutlined,
  ContainerOutlined, ProfileOutlined, SnippetsOutlined, FormOutlined,
  DatabaseOutlined, BookOutlined, TagsOutlined, AppstoreOutlined,
  TableOutlined, UnorderedListOutlined, FolderOpenOutlined, FolderOutlined,
  BarChartOutlined, PieChartOutlined, LineChartOutlined, FundOutlined,
  DotChartOutlined, AreaChartOutlined,
  BankOutlined, DollarOutlined, EuroOutlined, CalculatorOutlined,
  AccountBookOutlined, CreditCardOutlined, MoneyCollectOutlined, WalletOutlined,
  PercentageOutlined,
  ShoppingCartOutlined, ShoppingOutlined, ShopOutlined, GiftOutlined,
  InboxOutlined, DropboxOutlined,
  CarOutlined, RocketOutlined, CloudUploadOutlined, CloudDownloadOutlined,
  UserOutlined, TeamOutlined, IdcardOutlined, ContactsOutlined,
  SolutionOutlined, UsergroupAddOutlined,
  ToolOutlined, SettingOutlined, ApiOutlined, ControlOutlined, ExperimentOutlined,
  HomeOutlined, ApartmentOutlined, ClusterOutlined, GlobalOutlined, BuildOutlined,
  SafetyOutlined, AuditOutlined, FlagOutlined, StarOutlined,
  BellOutlined, MailOutlined, CloudOutlined, LockOutlined,
};

/** Перевірка, чи `acqKey` зареєстрований у каталозі. */
export function acqIsKnownIcon(acqKey: string | null | undefined): boolean {
  if (!acqKey) return false;
  return acqKey in ICON_COMPONENTS;
}

/**
 * Рендер іконки за ключем. Якщо ключ невідомий — повертає `null` (UI може
 * показати placeholder). Не throws.
 */
export function acqRenderIcon(
  acqKey: string | null | undefined,
  acqStyle?: React.CSSProperties,
): React.ReactNode {
  if (!acqKey) return null;
  const Comp = ICON_COMPONENTS[acqKey];
  if (!Comp) return null;
  return <Comp style={acqStyle} />;
}

/** Усі ключі (для пошуку, тестів). */
export function acqListIconKeys(): string[] {
  return Object.keys(ICON_COMPONENTS);
}
